// kte.swiperInit();